import { render } from "./ConversationMessages.vue?vue&type=template&id=66addf4e&scoped=true"
import script from "./ConversationMessages.vue?vue&type=script&lang=js"
export * from "./ConversationMessages.vue?vue&type=script&lang=js"

import "./ConversationMessages.vue?vue&type=style&index=0&id=66addf4e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66addf4e"]])

export default __exports__